import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface InteriorTrimsDoorsAndMirrorsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const InteriorTrimsDoorsAndMirrors: React.FC<InteriorTrimsDoorsAndMirrorsProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [interiorTrimsDoorsAndMirrors, set_interiorTrimsDoorsAndMirrors] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Interior Trims, Doors, and Mirrors']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Interior Trims, Doors, and Mirrors': [b.values?.['Interior']?.['Interior Trims, Doors, and Mirrors']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Interior Trims, Doors, and Mirrors';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(interiorTrimsDoorsAndMirrors)}
                />
            ) : (
                <MoneyBox
                    id={'interiorTrimsDoorsAndMirrors'}
                    allowNegative={false}
                    value={interiorTrimsDoorsAndMirrors}
                    onChange={(value) => set_interiorTrimsDoorsAndMirrors(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
